import React, { createContext, ReactElement, useMemo } from 'react';
import { AxiosTencerAdminApiClient } from 'app/shared/infrastructure/api/AxiosTencerAdminApiClient';
import { ApiSettingsRepository } from 'app/modules/settings/infrastructure/repository/api/ApiSettingsRepository';
import { SettingsRepository } from 'app/modules/settings/domain/repository/SettingsRepository';
import { BannerRepository } from 'app/modules/settings/domain/repository/BannerRepository';
import { ApiBannerRepository } from 'app/modules/settings/infrastructure/repository/api/ApiBannerRepository';
import { MaintenanceRepository } from 'app/modules/settings/domain/repository/MaintenanceRepository';
import { ApiMaintenanceRepository } from 'app/modules/settings/infrastructure/repository/api/ApiMaintenanceRepository';
import { ApiShipmentLeadTimeRepository } from 'app/modules/settings/infrastructure/repository/api/ApiShipmentLeadTimeRepository';
import { ShipmentLeadTimeRepository } from 'app/modules/settings/domain/repository/ShipmentLeadTimeRepository';
import { ProductSyncRepository } from 'app/modules/settings/domain/repository/ProductSyncRepository';
import { ApiProductSyncRepository } from 'app/modules/settings/infrastructure/repository/api/ApiProductSyncRepository';

export interface IDependencyInjection {
    settingsRepository: SettingsRepository,
    bannerRepository: BannerRepository,
    maintenanceRepository: MaintenanceRepository,
    shipmentLeadTimeRepository: ShipmentLeadTimeRepository
    productSyncRepository: ProductSyncRepository
}

export const DependencyInjectionContext = createContext<IDependencyInjection>(
    {} as IDependencyInjection,
);

type ProviderProps = {
    children: ReactElement,
};

export const DependencyInjectionProvider = ({ children }: ProviderProps): ReactElement => {
    const tencerAdminApiClient = new AxiosTencerAdminApiClient();

    const stateValues = useMemo(() => {
        const settingsRepository = new ApiSettingsRepository(tencerAdminApiClient);
        const bannerRepository = new ApiBannerRepository(tencerAdminApiClient);
        const maintenanceRepository = new ApiMaintenanceRepository(tencerAdminApiClient);
        const shipmentLeadTimeRepository = new ApiShipmentLeadTimeRepository(tencerAdminApiClient);
        const productSyncRepository = new ApiProductSyncRepository(tencerAdminApiClient);

        return {
            settingsRepository,
            bannerRepository,
            maintenanceRepository,
            shipmentLeadTimeRepository,
            productSyncRepository,
        };
    }, []);

    return (
        <DependencyInjectionContext.Provider value={stateValues}>
            {children}
        </DependencyInjectionContext.Provider>
    );
};
